import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';

import {LogService} from '../../../../services/log.service';


export enum ContentSize {
	Small = 30,
	Medium = 20,
	Large = 10
	// Small = '30',
	// Medium = '20',
	// Large = '10'
}


@Component({
	selector: 'page',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit, AfterViewInit {
	constructor(
		private log: LogService
	) {}


	ContentSize = ContentSize;		// enable enum in template
	@Input() contentSize = ContentSize.Large;
	// @Output() linkClick = new EventEmitter();


	ngOnInit() {
		console.log('PageComponent, ngOnInit');
	}


	ngAfterViewInit() {
		console.log('PageComponent, ngAfterViewInit');

		// console.log('this.label');
		// console.log(this.label);
		// console.log('this.link');
		// console.log(this.link);

		console.log('this.contentSize');
		console.log(this.contentSize);

	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/page/page.component.ts